// Google Maps Api Key
// IMPORTANT: this API key will be used in ELEMENT451 sites ONLY
export const mapsApiKey = 'AIzaSyCk0wjsZNK8xUmR7Tr8CzQ6orvkDeZyuDE';
